import React from 'react'
import { AreaChart, Area, ResponsiveContainer } from 'recharts'

const Sparkline = ({ data = [], color = '#1f9f93', height = 32, width = 80 }) => {
  const chartData = data.map((value, i) => ({
    v: typeof value === 'object' ? parseFloat(value.total || value.amount || 0) : parseFloat(value),
    i,
  }))

  if (chartData.length < 2) return null

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 2, right: 0, left: 0, bottom: 2 }}>
          <defs>
            <linearGradient id={`spark-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.3} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#spark-${color.replace('#', '')})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  )
}

export default Sparkline
